import { DashboardCustomer, useMelioIntl } from '@melio/ar-domain';
import { Table, TableColumnDef } from '@melio/penny';
import { useMemo } from 'react';

import { CustomerActions } from '../../types';
import { AmountWithInvoicesCountCell, CustomerActionCell, InvoicesCell } from '../table-cells';

export const useCustomersTableColumns = () => {
  const { formatMessage } = useMelioIntl();

  const columns = useMemo<TableColumnDef<DashboardCustomer, CustomerActions>[]>(
    () => [
      {
        id: 'customerName',
        size: 'm',
        header: formatMessage('ar.dashboard.activities.customersTable.columns.customer.label'),
        cell: ({ row }) => <Table.Cell data-testid="customer-name">{row.companyName}</Table.Cell>,
      },
      {
        id: 'email',
        header: formatMessage('ar.dashboard.activities.customersTable.columns.email.label'),
        cell: ({ row }) => <Table.Cell data-testid="customer-email">{row.email ?? ''}</Table.Cell>,
        size: 's',
      },
      {
        id: 'invoices',
        header: formatMessage('ar.dashboard.activities.customersTable.columns.invoices.label'),
        cell: ({ row, meta }) => <InvoicesCell customer={row} onClick={meta?.onDisplayInvoices} />,
        size: 's',
      },
      {
        id: 'paid',
        header: formatMessage('ar.dashboard.activities.customersTable.columns.paid.label'),
        cell: ({ row }) => <AmountWithInvoicesCountCell overview={row.invoicesOverview.paid} fieldName="paid" />,
        size: 's',
      },
      {
        id: 'openBalance',
        header: formatMessage('ar.dashboard.activities.customersTable.columns.openBalance.label'),
        cell: ({ row }) => <AmountWithInvoicesCountCell overview={row.invoicesOverview.open} fieldName="openBalance" />,
        size: 's',
      },
      {
        id: 'actions',
        cell: CustomerActionCell,
        size: 'xs',
      },
    ],
    [formatMessage]
  );

  return columns;
};
